import Aetherton1 from '../Aetherton/Atherton (1).webp'
import Aetherton2 from '../Aetherton/Atherton (2).webp'
import Aetherton3 from '../Aetherton/Atherton (3).webp'
import Aetherton4 from '../Aetherton/Atherton (4).webp'
import Aetherton5 from '../Aetherton/Atherton (5).webp'
import Aetherton6 from '../Aetherton/Atherton (6).webp'
import Aetherton7 from '../Aetherton/Atherton (7).webp'
import Aetherton8 from '../Aetherton/Atherton (8).webp'
import Aetherton9 from '../Aetherton/Atherton (9).webp'
import Aetherton10 from '../Aetherton/Atherton (10).webp'
import Aetherton11 from '../Aetherton/Atherton (11).webp'
import Aetherton12 from '../Aetherton/Atherton (12).webp'
import Aetherton13 from '../Aetherton/Atherton (13).webp'
import Aetherton14 from '../Aetherton/Atherton (14).webp'

const Aethertonimages =[
Aetherton1,Aetherton2,Aetherton3,Aetherton4,Aetherton5,Aetherton6,Aetherton7,Aetherton8,Aetherton9,Aetherton10,Aetherton11,Aetherton12,Aetherton13,Aetherton14
]

export default Aethertonimages;